import Vue from 'vue';
import Router from 'vue-router';
import authRoutes from '@/core/shared/auth/auth-routes';
import store from '@/core/store';
import deepmerge from 'deepmerge';
import { sync } from 'vuex-router-sync';

Vue.use(Router);
const appRoutes = [
  {
    name: 'home',
    path: '/home',
    component: () => import('@/Home'),
  },

  {
    name: 'sign-up-welcome',
    path: '/sign-up-welcome',
    component: () => import('@/sign-up/SignUpWelcome'),
  },
  {
    name: 'sign-up',
    path: '/sign-up',
    component: () => import('@/sign-up/SignUp'),
  },

  {
    name: 'bundles',
    path: '/bundles/all',
    component: () => import('@/bundle/BundlesRoute'),
  },
  {
    name: 'new-bundle',
    path: '/new-bundle/:bundleId?',
    props: true,
    component: () => import('@/bundle/show/NewBundleRoute'),
  },
  {
    name: 'edit-bundle',
    path: '/edit-bundle/:bundleId',
    props: true,
    component: () => import('@/bundle/show/EditBundleRoute'),
    redirect: { name: 'tab-details' },
    children: [
      {
        name: 'tab-details',
        path: 'details',
        props: true,
        component: () => import('@/bundle/show/subroutes/TabDetailsRoute'),
      },
      {
        name: 'tab-contents',
        path: 'contents',
        props: true,
        component: () => import('@/bundle/show/subroutes/TabContentsRoute'),
      },
      {
        name: 'tab-availability',
        path: 'availability',
        props: true,
        component: () => import('@/bundle/show/subroutes/TabAvailabilityRoute'),
      },
    ],
  },

  {
    name: 'content-ownerships',
    path: '/content/all',
    component: () => import('@/content-ownership/ContentOwnershipsRoute'),
  },
  {
    name: 'new-content-ownership',
    path: '/content/new',
    component: () =>
      import('@/content-ownership/show/NewContentOwnershipRoute'),
  },
  {
    name: 'pending-content-ownership',
    path: '/pending-content/:contentOwnershipId',
    props: true,
    component: () =>
      import('@/content-ownership/show/PendingContentOwnershipRoute'),
  },
  {
    name: 'content-ownership',
    path: '/content/:contentOwnershipId',
    props: true,
    component: () =>
      import('@/content-ownership/show/ContentOwnershipShowRoute'),
    redirect: { name: 'tab-content' },
    children: [
      {
        name: 'tab-content',
        path: 'content',
        props: true,
        component: () =>
          import('@/content-ownership/show/subroutes/TabContentRoute'),
      },
      {
        name: 'tab-pricing',
        path: 'pricing',
        props: true,
        component: () =>
          import('@/content-ownership/show/subroutes/TabPricingRoute'),
      },
      {
        name: 'tab-cds',
        path: 'cds',
        props: true,
        component: () => import('@/content-ownership/show/subroutes/TabCDSRoute'),
      },
      {
        name: 'tab-eula',
        path: 'eula',
        props: true,
        component: () => import('@/content-ownership/show/subroutes/TabEULARoute'),
      },
      {
        name: 'tab-steam',
        path: 'steam',
        props: true,
        component: () => import('@/content-ownership/show/subroutes/TabSteamRoute'),
      },
      {
        name: 'tab-update-notes',
        path: 'update-notes',
        props: true,
        component: () => import('@/content-ownership/show/subroutes/TabUpdateNoteRoute'),
      },
    ],
  },

  {
    name: 'analytics',
    path: '/analytics',
    component: () => import('@/analytics/ContentOwnershipAnalyticsRoute'),
  },
  {
    name: 'admin',
    path: '/admin',
    component: {
      render (h) {
        return h('router-view');
      },
    },
    children: [
      {
        name: 'tax-details',
        path: 'tax-details',
        component: () => import('@/admin/tax-details/TaxDetailsRoute'),
      },
      {
        name: 'organization-details',
        path: 'organization-details',
        component: () =>
          import('@/admin/organization-details/OrganizationDetails'),
      },
      {
        name: 'monthly-statements',
        path: 'monthly-statements',
        component: () =>
          import('@/admin/monthly-statements/MonthlyStatementsRoute'),
      },
    ],
  },
  {
    path: '*',
    redirect: { name: 'home' },
  },
];
const router = new Router({
  mode: 'history',
  routes: [
    ...authRoutes,
    ...appRoutes.map(route =>
      deepmerge(route, {
        meta: {
          isAppRoute: true,
        },
      }),
    ),
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(({ meta }) => meta.isAppRoute)) {
    if (!store.getters.currentOrganization) {
      await new Promise((resolve, reject) => {
        const unwatch = store.watch(
          (state, getters) => getters.currentOrganization,
          val => {
            if (val) {
              unwatch();
              resolve();
            }
          },
        );
      });
    }
  }
  next();
});

sync(store, router);

export default router;
